import { useSyncExternalStore } from "react";

export function isTouch(): boolean {
  return window.matchMedia("(pointer: coarse)").matches;
}

export function useIsTouch(): boolean {
  const mql = window.matchMedia("(pointer: coarse)");

  const subscribe = (cb: () => void) => {
    mql.addEventListener("change", cb);
    return () => mql.removeEventListener("change", cb);
  };

  return useSyncExternalStore(
    subscribe,
    () => mql.matches,
    () => false
  );
}

export function isIOS(): boolean {
  // iPad на iPadOS маскируется под Mac — определяем по тач-поддержке
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  );
}
